<template lang="html">
  <div class="display_main">
    <div class="explanation">
      <div class="text">
        <span>コースマップ</span>
      </div>
      <!--印刷エリア-->
      <div class="printeare">
        <!--印刷ボタン-->
        <div class="noprint">
        <!-- <b-button class="noprint" variant="outline-primary" @click="print">プリント</b-button> -->
          <a href=""><img src="../assets/img/print.png" @click="print"></a>
        </div>
        <!--鑑賞コースID-->
        <div class="print_meg">
          <span>鑑賞コースID:{{this.caseID}}</span>
        </div>
      </div>
    </div>
    <!--詳細画面の表示-->
    <div class="detail_main">
      <detailmain :exhibits="items" :keyslist="otherkeys" v-on:itemsupdata="itemsupdata"></detailmain>
    </div>
  </div>
</template>

<script>
import detailmain from "./details/details_main.vue";
import axios from 'axios';

export default {
  components: {
    // subexplanation,
    detailmain,
  },

  data(){
    return{
      items: [], //展示物情報のリスト
      keylist: [], 
      otherkeys: [],
      caseID: "",
    }
  },

  methods: {
    //展示物の情報取得
    getID() {
      this.caseID = this.$route.query.caseID
      this.items = this.$route.query.exhibitlist
      this.otherkeys = this.$route.query.keywodslist.slice(0, 11)
      alert('このコースのIDは' + this.caseID + 'で、再利用する場合、このIDを使ってください。');
    },
    //修正した鑑賞コースの保存
    uploadItems() {
      window.console.log("will be upload")
      axios.post('/api/displaymain',{
        case_ID: this.caseID,
        itemlist: this.items
      });
    },
    //画面印刷
    print() {
      print("display_main")
    },
    //詳細画面との展示物情報の連携
    itemsupdata: function(childValue) {
      this.items = childValue
    }
  },
  created() {
      this.getID()
      // this.getItems()
      // window.console.log(this.items)
  },
  //画面が閉じる際の処理
  mounted(){
    window.onbeforeunload= (e)=>{
      e = e || window.event;
      if (e) {
        e.returnValue = "ok"
        this.uploadItems()
      }
      window.console.log(this.items)
    }
  }
};
</script>

<style lang="css">
/* @import ".src/assets/CSS/web-display-main.css" */
.display_main{
  width: 1300px;
  height: 720px;
  margin: auto;
  background-image: url("/static/img/39865.jpg");
  /* text-align: ceentr; */
  overflow: hidden;
}

.display_main .explanation{
  width: 1200px;
  height: 50px;
  margin: auto;
  margin-top: 3px;
  display: flex;
}
.display_main .explanation .text{
  width: 800px;
  height: 50px;
  float: left;
  text-align: center;
}

.display_main .explanation .text span{
  font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
    "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
  color: #333333;
  font-size: 40px;
}

.display_main .explanation .printeare{
  width: 300px;
  height: 50px;
  margin: auto;
  margin-left: 15px;
  display: flex;
} 

.display_main .explanation .printeare .noprint{
  width: 50px;
  height: 50px;
  margin-left:15px;
  margin: auto;
  float: left;
} 

.display_main .explanation .printeare .noprint img{
  width: 100%;
  height: 100%;
} 

.display_main .explanation .printeare .print_meg{
  width: 230px;
  height: 50px;
  margin: auto;
} 

.display_main .explanation .printeare .print_meg span{
  margin: auto;
  text-align: center;
  font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
    "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
  color: #333333;
  font-size: 20px;
  background-color:rgb(252, 252, 252, 0.1)
} 
</style>
